<template>
  <div class="mobile-container">
    <!-- 头部导航 -->
    <div class="header">
      <div class="header-title">{{ title }}</div>
    </div>

    <!-- 表单内容 -->
    <div class="form-content">
      <div class="mobile-form">
        <div class="form-item">
          <label class="form-label">公函号：</label>
          <div class="form-input ">{{ manageMentInfo.missiveNumber }}</div>
        </div>

        <div class="form-item">
          <label class="form-label">公函标题：</label>
          <div class="form-input">{{ manageMentInfo.missiveTitle }}</div>
        </div>

        <div class="form-item">
          <label class="form-label">称呼：</label>
          <div class="form-input">{{ manageMentInfo.callName }}</div>
        </div>

        <div class="form-item">
          <label class="form-label">公函内容：</label>
          <div
            class="form-input content-box"
            v-html="manageMentInfo.missiveContent"
          ></div>
        </div>

        <div class="form-item">
          <label class="form-label">附件：</label>
          <div class="form-input" style="border: none">
            <span
              class="file-name"
              style="margin-right: 16px"
              v-if="manageMentInfo.annexName"
              >{{ manageMentInfo.annexName }}</span
            >
            <span
              class="preview-btn"
              @click="
                handlePreviewFile(
                  manageMentInfo.annexPath,
                  manageMentInfo.annexName
                )
              "
              v-if="manageMentInfo.annexName"
              >预览</span
            >
          </div>
        </div>

        <div class="form-item">
          <label class="form-label">联系人：</label>
          <div class="form-input">{{ manageMentInfo.contacts }}</div>
        </div>

        <div class="form-item">
          <label class="form-label">座机/电话：</label>
          <div class="form-input">{{ manageMentInfo.phoneNumber }}</div>
        </div>

        <div class="form-item">
          <label class="form-label">开函时间：</label>
          <div class="form-input">{{ manageMentInfo.missiveDate }}</div>
        </div>
      </div>
    </div>

    <!-- 底部按钮 -->
    <div class="footer-buttons">
      <el-button
        class="btn-disagree"
        @click="confirmManage('4')"
        size="mini"
        type="danger"
        >不同意</el-button
      >
      <el-button
        class="btn-agree"
        @click="confirmManage('3')"
        size="mini"
        type="primary"
        >同意</el-button
      >
      <el-button class="btn-preview" @click="lookPdf" size="mini" type="primary"
        >预览</el-button
      >
    </div>

    <!-- 弹窗组件 -->
    <MessageBox
      ref="messageBox"
      @approve="handleApprove"
      @reject="handleReject"
    />
  </div>
</template>

<script>
import MobileApi from "@/api/mobile";
import { mapGetters } from "vuex";
import MessageBox from "./messageBox.vue";
export default {
  name: "mobile",
  components: {
    MessageBox
  },
  data() {
    return {
      Api: new MobileApi(),
      manageMentInfo: {
        missiveNumber: "", //公函号
        missiveTitle: "", //标题
        call: "",
        callName: "", //称呼
        missiveContent: "", //公函内容
        contacts: "", //联系人
        phoneNumber: "", //联系电话
        missiveId: "", //公函id
        missiveDate: "", //开函时间
        annexPath: "", //附件路径
        annexName: "" //附件名称
      }
    };
  },
  props: {
    type: {
      type: String,
      default: ""
    },
    missiveId: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    }
  },
  computed: {
    ...mapGetters(["token"])
  },

  mounted() {
    this.getInfo();
  },
  methods: {
    handlePreviewFile(filePath, fileName) {
      console.log(filePath, fileName);

      let src = `/share-foreign/commannex/viewAnnex?path=${filePath}&token=${this.token}`;
      if (fileName.match(/\.pdf$/) || fileName.match(/\.PDF$/)) {
        window.open(src);
      } else {
        this.$message("仅支持pdf类型文件的预览");
      }
    },
    getInfo() {
      this.Api.getDetailOne({
        missiveId: this.missiveId
      }).then(res => {
        for (let key in this.manageMentInfo) {
          this.manageMentInfo[key] = res.data[key];
        }
        console.log(res.data);
      });
    },
    //预览pdf
    lookPdf() {
      if (this.missiveId) {
        window.open(
          "/share-foreign/missive/missiveManage/printMissive?" +
            "missiveId=" +
            this.missiveId +
            "&token=" +
            this.token
        );
      }
    },
    confirmManage(status) {
      if (status === "3") {
        // 显示确认弹窗
        this.$refs.messageBox.showConfirm({
          title: "提示",
          message: "是否确认同意审批？"
        });
      } else {
        // 显示输入弹窗
        this.$refs.messageBox.showInput({
          title: "请输入审批意见",
          placeholder: ""
        });
      }
    },

    // 处理同意操作
    handleApprove() {
      let obj = {
        missiveId: this.missiveId,
        remake: "",
        type: "3"
      };

      this.Api.examineApproval(obj).then(res => {
        this.$message({ message: res.msg, type: "success" });
        this.$emit("submit");
      });

      // 这里可以调用API提交审批结果
    },

    // 处理不同意操作
    handleReject(reason) {
      let obj = {
        missiveId: this.missiveId,
        remake: reason,
        type: "4"
      };
      this.Api.examineApproval(obj).then(res => {
        this.$message({ message: res.msg, type: "success" });
        this.$emit("submit");
      });

      // 这里可以调用API提交审批结果
    }
  }
};
</script>

<style lang="scss" scoped>
.mobile-container {
  min-height: 100vh;

  display: flex;
  flex-direction: column;
  height: 100vh; // 设置固定高度
  overflow: hidden; // 防止整体滚动
}

.header {
  background-color: #9fd3f6;
  height: 40px;
  display: flex;
  align-items: center;
  position: relative;
  z-index: 100;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding-left: 20px;
  flex-shrink: 0; // 防止头部被压缩

  .header-title {
    color: #000;
    font-size: 18px;
    font-weight: 500;
  }
}

.form-content {
  flex: 1;
  padding-bottom: 80px;
  overflow-y: auto; // 允许垂直滚动
  overflow-x: hidden; // 隐藏水平滚动
  -webkit-overflow-scrolling: touch; // iOS 平滑滚动
}

.mobile-form {
  border-radius: 8px;
}

.form-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 15px;
  min-height: 40px; // 确保每行有最小高度

  &:last-child {
    margin-bottom: 0;
  }

  .form-label {
    width: 80px; // 固定宽度而不是最小宽度
    font-size: 14px;
    color: #333;
    font-weight: 500;
    line-height: 40px; // 与input高度一致
    margin-right: 4px;
    flex-shrink: 0;
    text-align: right;
  }

  .form-input {
    flex: 1;

    border: 1px solid #e9ecef;
    color: #495057;
    font-size: 14px;
    border-radius: 4px;
    padding: 10px 15px;
    line-height: 1.5;
    min-height: 20px;
    word-wrap: break-word;
    display: flex;
    align-items: center;

    &.content-box {
      white-space: pre-wrap; /* 保留换行并自动换行 */
      word-break: break-all; /* 单词太长就打断换行 */
      min-height: 120px;
      white-space: pre-wrap;
      align-items: flex-start;
      padding-top: 10px;
    }

    .file-name {
      color: #333;
      font-size: 14px;
      margin-right: 10px;
    }

    .preview-btn {
      color: #4a90e2;
      font-size: 14px;
      cursor: pointer;
      text-decoration: none;

      &:hover {
        color: #357abd;
        text-decoration: underline;
      }
    }
  }
}

.footer-buttons {
  position: fixed;
  background-color: #fff;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  padding: 15px;

  display: flex;
  gap: 10px;
  z-index: 999;
  justify-content: center;
  .el-button {
    width: 80px;
    height: 40px;
    font-size: 16px;
    font-weight: 500;
    border-radius: 6px;
    border: none;
  }
}

// // 移动端响应式
@media (max-width: 768px) {
  .form-content {
    padding: 10px;
    padding-bottom: 60px;
  }

  .form-item {
    margin-bottom: 12px;
    min-height: 36px;

    .form-label {
      width: 70px;
      font-size: 13px;
      line-height: 36px;
      margin-right: 4px;
    }

    .form-input {
      font-size: 13px;
      padding: 8px 12px;

      &.content-box {
        min-height: 100px;
        padding-top: 8px;
      }
    }
  }

  .footer-buttons {
    background-color: #fff;
    padding: 12px;
    display: flex;
    display: flex;
    justify-content: center;

    .el-button {
      flex-grow: 0;
      width: 80px;
      height: 36px;
      font-size: 14px;
    }
  }

  .header {
    padding-left: 20px;

    .header-title {
      font-size: 16px;
    }
  }
}
</style>
